import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = ({ onBack }) => {
  return (
    <motion.div 
      className="legal-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="legal-header">
        <motion.button
          className="back-button-legal"
          onClick={onBack}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <ArrowLeft size={20} />
          Back
        </motion.button>
        <h1>Privacy Policy</h1>
      </div>
      
      <div className="legal-content">
        <p className="effective-date"><strong>Effective Date:</strong> July 18, 2025</p>
        
        <p>This Privacy Policy describes how BrainRotAI ("we," "us," or "our") collects, uses, and shares information when you use our Minecraft video generation service ("Service").</p>
        
        <h2>Information We Collect</h2>
        <ul>
          <li><strong>Account Information:</strong> When you create an account, we collect your email address.</li>
          <li><strong>Usage Data:</strong> We collect information about your use of the Service, such as the number of videos generated and the topics or scripts you provide. This data is aggregated and anonymized to improve the service.</li>
          <li><strong>Payment Information:</strong> We do not directly store your payment information. Payment processing is handled by Stripe, a third-party payment processor, and their privacy policy applies to the handling of your payment data.</li>
        </ul>
        
        <h2>How We Use Your Information</h2>
        <ul>
          <li>We use your email address to communicate with you about your account and the Service.</li>
          <li>We use usage data to improve the Service and develop new features.</li>
          <li>We do not share your information with third parties except as necessary to provide the Service (e.g., Stripe for payment processing) or as required by law.</li>
        </ul>
        
        <h2>Data Retention</h2>
        <p>We retain your email address for as long as your account is active. We retain the most recent video generation request associated with your account.</p>
        
        <h2>Data Security</h2>
        <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure.</p>
        
        <h2>Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us at support@brainrotai.com.</p>
        
        <h2>Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will post any changes on this page.</p>
        
        <h2>Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at support@brainrotai.com.</p>
      </div>
    </motion.div>
  );
};

export default PrivacyPolicy;
